
<template>
    <div class="container">
    <div class="contact-block text-left ml-5 mr-5">


        <div class="row">
            <div class="col">
                <div class="block_title">{{ $t('newsletter.title') }}</div>

                {{ $t('newsletter.content') }}
            </div>
            <div class="col my-auto text-center">
                <!-- <div>
                    <img src="../assets/img/illustrations/newsletter.svg" class="nwlt" alt="newsletter agrivitech">
                </div> -->

                <data id="mj-w-res-data" data-token="3969007b0ea9cb0e4f7c22889075e369" class="mj-w-data" data-apikey="1Sfo" data-w-id="kY6" data-lang="fr_FR" data-base="https://app.mailjet.com" data-width="760" data-height="508" data-statics="statics"></data>

                <div class="mj-w-button mj-w-btn" style="font-family: Ubuntu, Helvetica; color: white; padding: 0px 25px; background-color: rgb(33, 227, 159); text-align: center; vertical-align: middle; display: inline-block;" data-token="3969007b0ea9cb0e4f7c22889075e369">
                    <div style="display: table; height: 65px;">
                        <div style="display: table-cell; vertical-align: middle;">
                            <div class="mj-w-button-content" style="font-family:Ubuntu, Helvetica; display: inline-block; text-align: center; font-size: 30px; vertical-align: middle;"><b>{{ $t('newsletter.aboBtn') }}</b></div>
                        </div>
                    </div>
                </div>

                
            </div>
        </div>

        

    </div>

  </div>
</template>

<script>
export default {
    name: 'MailjetNewsLetter',
    data(){
      return {
      }
    },
}
</script>


<style lang="scss" scoped>


.contact-block {
    color: white;
    font-weight: 400;
    font-size: 15px;
    background-color: var(--mainBlue);
    padding: 20px;
    border-radius: 5px;
    text-align: center;
    margin-bottom: 100px;
    .tagline{
    padding: 50px 0px 20px 0px;
    }
    .styledInput{
        margin: auto;
        border-radius: 25px;
        max-width: 300px;
        height: 45px;
    }
    .button-input{
        background-color: var(--mainGreen);
        color: white;
        position: relative;
        height: 40px;
        top: -42.5px;
        left: 105px;
        z-index: 20;
        &:hover{
            background-color: var(--mainBlue);
        }
    }

    .block_title {
        color: var(--mainGreen);
        text-align: left;
        font-weight: 600;
        font-size: 25px;
        padding-bottom: 15px;
    }

    .nwlt{
        height: 100px;
        margin-bottom: 20px;
    }

    // .imgContact{
    //     background-image: url('../assets/img/contactezNous.png');
    //     background-repeat: no-repeat;
    //     background-position: center;
    //     background-size: cover;
    //     height: 20%;
    // }
  }

  
</style>